(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"), require("ui"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "core", "ui"], factory);
	else if(typeof exports === 'object')
		exports["widget-locale-switch-abc"] = factory(require("base"), require("core"), require("ui"));
	else
		root["widget-locale-switch-abc"] = factory(root["base"], root["core"], root["ui"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Filename : main.js
	               *  Description: Some description
	               *  ----------------------------------------------------------------
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.name = 'widget-locale-switch-abc';

	    // External Dependencies
	    var base = __webpack_require__(3);
	    var core = __webpack_require__(4);
	    var ui = __webpack_require__(5);

	    // Internal Dependencies
	    var Model = __webpack_require__(6);
	    var MainCtrl = __webpack_require__(7);

	    var deps = [
	    core.name,
	    ui.name];


	    /**
	               * @ngInject
	               */
	    function run() {
	        // Module is Bootstrapped
	    }

	    module.exports = base.createModule(module.name, deps).
	    constant('WIDGET_NAME', module.name).
	    controller('MainCtrl', MainCtrl).
	    factory('model', Model).
	    run(run);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Models
	               * @module models
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {

	    'use strict';

	    /**
	                   * @constructor
	                   * @ngInject
	                   */
	    function WidgetModel(lpWidget, lpCoreUtils, $resource) {
	        var utils = lpCoreUtils;
	        var state = {
	            title: lpWidget.getPreference('title'),
	            icon: utils.resolvePortalPlaceholders(lpWidget.getPreference('thumbnailUrl')),
	            localeSwitchURL: utils.resolvePortalPlaceholders(lpWidget.getPreference('localeSwitchURL')) || '/portalserver/services/rest/v1/public/language/change' };



	        var model = {};
	        /**
	                         * @public
	                         * @return {Object} current model state
	                         */
	        model.getState = function () {
	            return state;
	        };

	        model.localeSwitchEndPoint = $resource(state.localeSwitchURL);
	        return model;
	    }

	    module.exports = WidgetModel;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Controllers
	               * @module controllers
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {

	    'use strict';

	    /**
	                   * Main controller
	                   * @ngInject
	                   * @constructor
	                   */

	    function MainCtrl(model, $rootScope, lpWidget, lpCoreUtils, lpCoreBus, lpCoreI18nUtils, lpCoreI18n, lpCoreError, $http, $timeout, $compile) {

	        var self = this;

	        self.state = model.getState();
	        self.utils = lpCoreUtils;
	        self.widget = lpWidget;
	        self.isMobileNative = lpWidget.getPreference('native') || false;
	        self.locales = lpWidget.getPreference('locales') || 'en-US';
	        self.localesWithCode = [];

	        function getCookie(name) {
	            var value = "; " + document.cookie;
	            var parts = value.split("; " + name + "=");
	            if (parts.length >= 2) return parts.pop().split(";").shift();
	        }

	        var arabicLabel = "العربية";
	        self.selectedLocale = getCookie('userLanguage') || 'en-US';
	        if (self.locales && self.locales.length > 0) {
	            self.locales = self.locales.split(',');
	            angular.forEach(self.locales, function (value, index) {
	                value = value.trim();
	                var langCode = value.split('-')[0];
	                var localeLabel = "";
	                if (langCode && langCode === 'ar') {
	                    localeLabel = arabicLabel;
	                } else {
	                    localeLabel = langCode.toUpperCase();
	                }
	                //do not set arabic temporarily
	                if (langCode && langCode !== 'ar') {
	                    self.localesWithCode.push({ 'lang_code': localeLabel, 'locale_code': value });
	                }
	            });
	        }

	        self.isSelectedLocale = function (localeCode) {
	            return localeCode === self.selectedLocale;
	        };

	        self.changeLocale = function (locale, event) {
	            if (event) {
	                event.preventDefault();
	            }
	            var localeArr = locale.split('-');
	            var params = {
	                'languageCode': localeArr[0],
	                'countryCode': localeArr[1] };

	            var divs = document.querySelectorAll('[data-pid^=widget-advanced-content-template-banner-]');
	            for (var i = 0; i < divs.length; i++) {
	                divs[i].style.height = '0';
	            }

	            if (document.querySelectorAll('[data-pid=widget-advanced-content-template-banner-' + localeArr[0] + ']').length > 0) {
	                document.querySelectorAll('[data-pid=widget-advanced-content-template-banner-' + localeArr[0] + ']')[0].style.height = '300px';
	            }

	            model.localeSwitchEndPoint.save(params, {}).
	            $promise.then(function (response) {
	                self.selectedLocale = locale;
	                window.sessionStorage.setItem("selected_locale", locale);
	                document.getElementsByTagName('html')[0].setAttribute('lang', localeArr[0]);
	                lpCoreBus.publish(lpCoreI18nUtils.LOCALE_CHANGE_EVENT, locale);
	            }, function (err) {
	                lpCoreError.captureException(err);
	            });
	        };

	        var selectedLocale = window.sessionStorage.getItem("selected_locale");
	        if (!selectedLocale) {
	            selectedLocale = self.selectedLocale;
	        }
	        self.changeLocale(selectedLocale);
	    }

	    MainCtrl.prototype.$onInit = function () {
	        // Do initialization here
	    };

	    module.exports = MainCtrl;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// widget-locale-switch-abc.js